export default __webpack_public_path__ + "static/media/adult-page-mobile.4c73d34c.png";